<template>
  <div class="success-tooltip cookie-tooltip">
    <h5>На сайте используются cookie-файлы</h5>
    <button @click.stop="closeTooltip()">
      <span :style="{ width: width }"></span>
      <span>Ок</span>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      second: 0,
      width: "0%",
    };
  },
  created() {
    this.tooltipTimer();
  },
  methods: {
    tooltipTimer() {
      this.second += 10;
      this.width = (this.second * 100) / 20000;
      this.width = this.width + "%";
      if (this.second < 20000) setTimeout(this.tooltipTimer, 10);
      else this.closeTooltip();
    },
    closeTooltip() {
      localStorage.setItem("isCookieTooltip", "1");
      this.$parent.isCookieTooltip = false;
    },
  },
};
</script>
